import { render, staticRenderFns } from "./SignUpBackButton.vue?vue&type=template&id=053850a4&scoped=true&"
import script from "./SignUpBackButton.vue?vue&type=script&lang=js&"
export * from "./SignUpBackButton.vue?vue&type=script&lang=js&"
import style0 from "./SignUpBackButton.vue?vue&type=style&index=0&id=053850a4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053850a4",
  null
  
)

export default component.exports